// Defining Moment Template - Common App Prompt #5
export const definingMomentTemplate = {
  id: 'definingMoment',
  title: 'Defining Moment',
  description: 'For accomplishments, events, or realizations that sparked personal growth and new understanding of yourself or others',
  sections: [
    {
      id: 'the_pivotal_moment',
      label: 'The Pivotal Moment',
      type: 'opening',
      prompt: 'What was the specific moment when everything shifted - when you realized something fundamental had changed?',
      coachVoice: "I want the exact moment of recognition. Not the event itself, but when you understood its significance.",
      sample: "I was standing in front of 200 middle schoolers, completely off-script from my planned presentation about renewable energy, when I realized I was actually enjoying their interruptions and questions. For someone who'd spent years avoiding public speaking, I was suddenly energized by the chaos of curious minds rather than terrified by it.",
      minWords: 80,
      unlockWords: 40
    },
    {
      id: 'what_this_revealed',
      label: 'What This Revealed',
      type: 'stakes',
      prompt: 'What did this moment expose about yourself that you hadn\'t understood before?',
      coachVoice: "Don't just say you discovered you were good at something. What deeper truth about who you are became visible through this experience?",
      sample: "I realized I'd been confusing introversion with fear. I wasn't actually energized by solitude - I was energized by deep, meaningful connections. The difference was that these kids were asking genuine questions about science, not making small talk. I thrived on intellectual engagement, not social performance.",
      minWords: 80,
      unlockWords: 40
    },
    {
      id: 'how_you_explored_this_discovery',
      label: 'How You Explored This Discovery',
      type: 'approach',
      prompt: 'Show me how you systematically explored and developed this new understanding of yourself.',
      coachVoice: "One moment of insight isn't enough. How did you test, develop, and integrate this new knowledge about yourself?",
      sample: "I started seeking out opportunities to explain complex ideas to different audiences - volunteering to tutor struggling physics students, creating YouTube videos breaking down environmental concepts, even convincing my family to let me lead our vacation planning by researching and presenting options. Each experience taught me more about how I learn and communicate best.",
      minWords: 100,
      unlockWords: 50
    },
    {
      id: 'your_evolved_self',
      label: 'Your Evolved Self',
      type: 'growth',
      prompt: 'How does this new self-understanding change the way you approach relationships, challenges, or decisions?',
      coachVoice: "I need to see the lasting impact. Give me specific evidence of how this insight actively shapes who you are now.",
      sample: "I now choose challenges based on intellectual curiosity rather than social comfort. When I had to pick between student government (traditional leadership) and starting a science communication club (uncharted territory), I chose the unknown because I'd learned I'm energized by sharing ideas, not managing people. I've stopped forcing myself into conventional leadership roles and started creating my own.",
      minWords: 80
    }
  ]
};